export const DISHES = [
  'Suprême de poulet pesto cerfeuil et noix',
  'Jambon grillé sauce moutarde',
  "Riz long à l'indienne et lait de coco",
  'Poisson frais du marché',
  'Filet mignon de porc aux herbes',
  'Emincé de dinde au curry',
  'Sauté de canard à la citronelle',
];

export const DISHES_EN = [
  'Donec blandit felis id dui mollis',
  'Sed porttitor placerat dui',
  'Orci varius natoque penatibus',
  'Quisque vestibulum',
  'Proin at vulputate nisi eget',
  'Nulla purus orci',
  'Etiam mollis lorem quis imperdiet',
];
